// extracted by mini-css-extract-plugin
export default {"header":"FilesGroup_header__W5ozo","content":"FilesGroup_content__04Hqu"};